module.exports = __webpack_public_path__ + "mainassets/img/fax.7a705b2c.svg";